export default __webpack_public_path__ + "static/media/blood-in-your-urine.09d5948c.png";